

































































import { SbpDeleteDefaultModalVue } from "fs-pb-vue2/vueModels/settings/SbpDeleteDefaultModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class SbpDeleteDefaultModal extends SbpDeleteDefaultModalVue {
  async mounted() {
    await this.init();
  }
}
